import { MODE_IDS } from 'common/utils/constants'

import {
  getPassengerTypeAdultMsg,
  getPassengerTypeSeniorMsg,
  getPassengerTypeYouthMsg,
} from './constants.messages'

export const NO_RESULTS_MODE = 'noResults'

export const DEFAULT_SEARCH_HOUR = 8
export const DEFAULT_SEARCH_HOUR_STRING = DEFAULT_SEARCH_HOUR < 10 ? `0${DEFAULT_SEARCH_HOUR}:00` : `${DEFAULT_SEARCH_HOUR}:00`

export const DEFAULT_MODE_IDS = [MODE_IDS.train, MODE_IDS.bus, MODE_IDS.plane]

export const VALID_MODE_IDS = [
  MODE_IDS.train,
  MODE_IDS.bus,
  MODE_IDS.ferry,
  MODE_IDS.plane,
  MODE_IDS.airport_transfer,
]

export const TAB_ORDER_PREFERENCES = {
  'airport-transfer': 5,
  ferry: 4,
  train: 3,
  bus: 2,
  plane: 1,
}

export const MODES_WITH_LEG_PAIRS = [
  'plane',
  'airport-transfer',
  'ferry',
]

export const TRANSITKINDS_WITH_DIRECT_OFFSITE = [
  'towncar',
  'shuttle',
]

export const FERRY_TYPES = {
  foot: 'foot',
  car: 'car',
}

export const CART_TYPES = {
  oneway: 'oneway',
  separate: 'separate',
  combined: 'combined',
  return: 'return',
}

export const PASSENGER_TYPES = {
  senior: 'senior',
  adult: 'adult',
  youth: 'youth',
}

export const PASSENGER_TYPE_OPTIONS = [
  { data: PASSENGER_TYPES.senior, getLabel: getPassengerTypeSeniorMsg, ageRange: '60+' },
  { data: PASSENGER_TYPES.adult, getLabel: getPassengerTypeAdultMsg, ageRange: '26-59' },
  { data: PASSENGER_TYPES.youth, getLabel: getPassengerTypeYouthMsg, ageRange: '0-25' },
]

export const TIME_FILTER_OPTIONS = {
  earlyMorning: 'earlyMorning',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
}

export const MIN_BUFFER_MINUTES = 60
